/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForSaasAws extends models.ServiceAccountCredentialsBaseForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForSaasAws");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForSaasAws.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForSaasAws>): ServiceAccountCredentialsBaseForSaasAws {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForSaasAws(), model);
        ServiceAccountCredentialsBaseForSaasAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForSaasAws>): ServiceAccountCredentialsBaseForSaasAws {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForSaasAws.newInstance(<ServiceAccountCredentialsBaseForSaasAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForSaasAws) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForSaasAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForSaasAws): boolean {
        if (models.ServiceAccountCredentialsBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForSaasAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
